import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["src", "onLoad", "onUnload", "onContentLoadStarted"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { useIframeCommunicationChannel } from './useIframeCommunicationChannel';
import { useHostOffsetOverride } from './useHostOffsetOverride';
export var StyledIframe = styled.iframe({
  border: 'none',
  width: '100%',
  height: '100%'
});
export var Iframe = function Iframe(_ref) {
  var src = _ref.src,
    onLoad = _ref.onLoad,
    onUnload = _ref.onUnload,
    onContentLoadStarted = _ref.onContentLoadStarted,
    passThroughProps = _objectWithoutProperties(_ref, _excluded);
  useEffect(function () {
    var handler = function handler(e) {
      if (e.data.type === 'windowUnload') {
        onUnload === null || onUnload === void 0 ? void 0 : onUnload();
      }
    };
    window.addEventListener('message', handler);
    return function () {
      window.removeEventListener('message', handler);
    };
  }, [onUnload]);
  useHostOffsetOverride();
  var channel = useIframeCommunicationChannel(src, _objectSpread(_objectSpread({}, passThroughProps), {}, {
    onContentLoadStarted: onContentLoadStarted
  }));
  return /*#__PURE__*/React.createElement(StyledIframe, _extends({
    title: "confluence-article-iframe",
    "data-testid": "confluence-page-iframe",
    name: channel.name,
    src: src,
    onLoad: onLoad
    // Grant features to iframe (Currently the same as smart card iframe's granted features)
    ,
    allow: "autoplay; fullscreen; encrypted-media; clipboard-write"
    // Same as "fullscreen" in "allow" attribute but it's considered a legacy attribute. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#attr-allowfullscreen
    // Need it in case the browser doesn't support "fullscreen" feature policy.
    ,
    allowFullScreen: true
  }, passThroughProps));
};